import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import BackToTop from './components/BackToTop';
import { tickerResults } from './data/results';

// Pages
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import OffsiteEventsPage from './pages/OffsiteEventsPage';
import TentSetupsPage from './pages/TentSetupsPage';
import DirectMailPage from './pages/DirectMailPage';
import FacebookEventsPage from './pages/FacebookEventsPage';
import EventResultsPage from './pages/EventResultsPage';
import TestimonialsPage from './pages/TestimonialsPage';
import FAQPage from './pages/FAQPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import AiBdcPage from './pages/AiBdcPage';


function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app">
        <style>{`
          /* App shell */
          .app {
            min-height: 100vh;
            display: flex;
            flex-direction: column;
          }
          main { flex: 1; }
        `}</style>

        {/* Global Results Ticker — shown on all pages */}
        <div className="results-ticker">
          <div className="ticker-scroll">
            {[...tickerResults, ...tickerResults].map((result, index) => (
              <div key={index} className="ticker-item">
                <strong>Results from {result.location}</strong> — {result.units} Units Sold — <span style={{color: '#FFC300'}}>${result.gross.toLocaleString()}</span>
              </div>
            ))}
          </div>
        </div>

        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/offsite-events" element={<OffsiteEventsPage />} />
            <Route path="/services/tent-setups" element={<TentSetupsPage />} />
            <Route path="/services/direct-mail" element={<DirectMailPage />} />
            <Route path="/services/facebook-events" element={<FacebookEventsPage />} />
            <Route path="/event-results" element={<EventResultsPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/services/ai-bdc" element={<AiBdcPage />} />
          </Routes>
        </main>
        <Footer />
        <BackToTop />
      </div>
    </Router>
  );
}

export default App;
